export enum ContactEntityType {    
    Opo = 1,
    Center = 2,
    Nkr = 3,
    Vendor = 4,
    Donor = 5,
    OtherGala = 6,
    Other = 7,
    SwapCourier
}